import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {ActivationService} from "../models/ActivationService";

export const ActivationServiceService = {
    getAll: async (): Promise<ApiResponse<ActivationService[]>> => {
        try {
            const response = await MainBackendAxios.get(`/activation-service/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
